// "Jump to latest" pill shown while viewing a historical context window.
type JumpToLatestButtonProps = {
  tabBgClass: string;
  onJump: () => void;
};

function JumpToLatestButton({ tabBgClass, onJump }: JumpToLatestButtonProps) {
  return (
    <div className="flex justify-center py-2 px-4">
      <button
        className={`flex items-center gap-2 px-4 py-2 rounded-full ${tabBgClass} text-white text-sm font-medium shadow-lg hover:opacity-90 transition-opacity`}
        onClick={onJump}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4"><path d="M12 5v14"/><path d="M5 12l7 7 7-7"/></svg>
        Jump to latest
      </button>
    </div>
  );
}

export default JumpToLatestButton;
